import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { DriftConfiguration } from '../models/configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private configUrl = '../../assets/config.json';
  private configuration: DriftConfiguration = {};
  private configLoaded = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  public loadConfiguration(): Observable<DriftConfiguration> {
    return this.http.get<DriftConfiguration>(this.configUrl).pipe(
      tap(config => {
        this.configuration = config;
        this.configureAmplify();
        this.configLoaded.next(true);
      })
    );
  }

  configureAmplify() {
    Amplify.configure({
      Auth: {
        region: 'us-west-2',
        userPoolId: environment.userPoolId,
        userPoolWebClientId: environment.appClientId,
        oauth: {
          domain: environment.domain,
          scope: ['aws.cognito.signin.user.admin', 'openid'],
          redirectSignIn: environment.redirectSignIn, // use http://localhost:4200/home for local testing
          redirectSignOut: environment.redirectSignOut, // use http://localhost:4200/home for local testing
          responseType: 'code'
        }
      }
    });
  }

  public setConfiguration(config: DriftConfiguration): void {
    this.configuration = config;
  }

  public getConfiguration(): DriftConfiguration {
    return this.configuration;
  }

  public configurationLoaded(): Observable<boolean> {
    return this.configLoaded.asObservable();
  }
}
